module.exports = __webpack_public_path__ + "Edge-68594da8b1218e2d5b808baa1253744c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/browser-icons/Edge.png
// module id = 1129
// module chunks = 0 1